import IDream from "motw_core/Entity/IDream";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";


export function UpdateLocalDreamState(updatedDream: IDream) {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    const newDreamsData = [...dreams.state.dreamsdata]
        .filter((dream) => dream.id !== updatedDream.id)
        .concat([updatedDream]);

    dreams.setState({ dreamsdata: newDreamsData });
}
